import { BaseRequest } from './BaseRequest';

export class CloneRequest extends BaseRequest {
    BotIdentifierDestination : string | null;
}